module.exports = __webpack_public_path__ + "images/help_v2/masthead_roadmap@2x-431bd549480842eed9a8791a5001f4aa.png";